
import React from "react";

interface SummaryPillProps {
  label: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  ariaLabel?: string;
}

const SummaryPill: React.FC<SummaryPillProps> = ({ label, icon, onClick, ariaLabel }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex items-center gap-1 px-3 py-1 rounded-full bg-card border border-border text-foreground/70 text-xs font-medium whitespace-nowrap shrink-0
    hover:bg-foreground/5 hover:border-brand hover:text-brand
    focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-1
    transition-colors"
    aria-label={ariaLabel || label}
  >
    {icon}
    <span>{label}</span>
  </button>
);

export default SummaryPill;
